import { render, staticRenderFns } from "./overview-main-card-table.component.vue?vue&type=template&id=3b0ff962&scoped=true&"
import script from "./overview-main-card-table.component.vue?vue&type=script&lang=ts&"
export * from "./overview-main-card-table.component.vue?vue&type=script&lang=ts&"
import style0 from "./overview-main-card-table.component.vue?vue&type=style&index=0&id=3b0ff962&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0ff962",
  null
  
)

export default component.exports